export interface FavoritesData {
  matches: string[];
  clubs: string[];
}

export function normalizeFavoriteIds(ids: unknown): string[] {
  if (!Array.isArray(ids)) return [];
  return [...new Set(ids.map(String).map((id) => id.trim()).filter(Boolean))];
}

export function parseFavoritesJson(raw: unknown): string[] {
  if (raw == null || raw === '') return [];
  if (Array.isArray(raw)) return normalizeFavoriteIds(raw);
  if (typeof raw !== 'string') return [];
  const trimmed = raw.trim();
  if (!trimmed) return [];
  try {
    const parsed = JSON.parse(trimmed) as unknown;
    if (Array.isArray(parsed)) return normalizeFavoriteIds(parsed);
  } catch {
    return normalizeFavoriteIds(trimmed.split(/[,;\n]+/));
  }
  return [];
}

export function serializeFavoritesJson(ids: string[]): string {
  return JSON.stringify(normalizeFavoriteIds(ids));
}

export function mergeFavorites(local: FavoritesData, remote: FavoritesData): FavoritesData {
  return {
    matches: normalizeFavoriteIds([...remote.matches, ...local.matches]),
    clubs: normalizeFavoriteIds([...remote.clubs, ...local.clubs]),
  };
}

export function favoritesEqual(a: FavoritesData, b: FavoritesData): boolean {
  const sort = (ids: string[]) => [...ids].sort();
  return (
    JSON.stringify(sort(a.matches)) === JSON.stringify(sort(b.matches))
    && JSON.stringify(sort(a.clubs)) === JSON.stringify(sort(b.clubs))
  );
}
